import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useAppDispatch } from '@widgets/SteppedQuiz/store/hooks';
import { addItemToHistory, setCurrentQuestionFromId, } from '@widgets/SteppedQuiz/store/reducers/question';
import { Wrapper, Button } from './styles';
function AnswerItem(props) {
    const { text, target, icon, questionId, } = props;
    const { copy, type } = text;
    const dispatch = useAppDispatch();
    return (_jsx(Wrapper, { children: _jsxs(Button, { type: "button", onClick: (event) => {
                const maybeId = parseInt(target, 10);
                if (Number.isNaN(maybeId)) {
                    window.open(target, '_self')
                        ?.focus();
                }
                else {
                    dispatch(setCurrentQuestionFromId(maybeId));
                    dispatch(addItemToHistory(questionId));
                }
            }, children: [icon
                    && (_jsx("svg", { children: _jsx("use", { xlinkHref: icon }) })), _jsx("span", { className: type === 'tag' ? 'tag tag--category' : 'h6', children: copy })] }) }));
}
export default AnswerItem;
